module.exports = __webpack_public_path__ + "img/logo_name.bcb4b708.png";